import { Checkbox } from '@popsure/dirty-swan';

import { AdjustPolicyCheckboxProps } from '../models';

export const AdjustPolicyOption = (
  props: AdjustPolicyCheckboxProps & {
    value: string[];
    setValue: (value: string[]) => void;
  }
) => {
  const { title, description, value, setValue, checkboxOptions } = props;

  const checkboxOptionLookup =
    checkboxOptions.reduce(
      (acc: Record<string, string>, { label, value: coValue }) => {
        acc[coValue] = label;
        return acc;
      },
      {}
    ) ?? {};

  return (
    <div className="">
      {title && <p className="p-h3">{title}</p>}
      {description && <p className="p-p mt16 tc-grey-600">{description}</p>}
      <Checkbox<string>
        classNames={{
          container: 'mt24',
          option: 'w30',
        }}
        wide
        bordered
        inlineLayout
        value={value}
        onChange={(newValue) => setValue(newValue)}
        options={checkboxOptionLookup}
      />
    </div>
  );
};
